// ne koristi se, linkove vucemo sa CMS-a
export const packageLinks = {
  'Mini Osnovni TV paket': '/Privatni/m-box/TV-PLUS-TV-TEL-/Paketi',
  'Box 2.1': '/Privatni/m-box/BOX-2-TV-NET-/Paketi',
  'Box 3.1': '/Privatni/m-box/BOX-3-TV-NET-TEL-/Paketi',
  'Box 4.1': '/Privatni/m-box/BOX-4-TV-NET-TEL-MOB-/Paketi',
  Max: '#',
  Plus: '#'
}

export function getClosestPackageNameLink (packageList = {}, packageName) {
  const simplifiedName = packageName.split('.')[0]
  let closestLink = '#'
  Object.entries(packageList).find(p => {
    if (p[0].split('.')[0].indexOf(simplifiedName) > -1) {
      closestLink = p[1]
    }
  })

  return closestLink
}
